import client from "./client";

export const login = (email: string, password: string) =>
  client.post("/auth/login", { email, password });

export const getMe = () => client.get("/auth/me");

export const updateProfile = (data: Record<string, unknown>) => client.patch("/auth/profile", data);

export const changePassword = (currentPassword: string, newPassword: string) =>
  client.post("/auth/change-password", { current_password: currentPassword, new_password: newPassword });

export const setup2FA = () => client.post("/auth/2fa/setup");

export const enable2FA = (code: string) => client.post("/auth/2fa/enable", { code });

export const disable2FA = (password: string) => client.post("/auth/2fa/disable", { password });

export const verify2FA = (challengeToken: string, code: string) =>
  client.post("/auth/2fa/verify", { challenge_token: challengeToken, code });

export const refreshAccessToken = (refreshToken: string) =>
  client.post("/auth/refresh", { refresh_token: refreshToken });

export const logoutApi = (refreshToken: string) =>
  client.post("/auth/logout", { refresh_token: refreshToken });

export const completeOnboarding = () =>
  client.post("/auth/complete-onboarding");

export const resetOnboarding = () =>
  client.post("/auth/reset-onboarding");

export const demoLogin = () =>
  client.post<{ access_token: string }>("/auth/demo-login");
